// extracted by mini-css-extract-plugin
export default {"icon":"src-components-Modules-revamp-TabStyle-css-module__icon--5H+Bq"};